module.exports = __webpack_public_path__ + "img/si.5a0703e0.svg";